import React, { useState } from "react";

const UserAddress = (props) => {
    const { userAddress, handleAddressSelect, handleAddAddressClick, onEdit } = props;

    const [visibleCount, setVisibleCount] = useState(3);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleShowMore = () => {
        setVisibleCount(userAddress.length); // Show all addresses
        setIsExpanded(true);
    };

    const handleShowLess = () => {
        setVisibleCount(3); // Show only the initial 3 addresses
        setIsExpanded(false);
    };

    return (
        <div>
            <div className="box-border">
                <span className="address_description">Select a delivery address from your address book or enter a new one for delivery.</span>
                {userAddress?.slice(0, visibleCount).map((item, i) => (
                    <div className="mt-4" key={i}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="loginid_data d-flex align-items-start" style={{ gap: '10px' }}>
                                <input
                                    type="radio"
                                    id={`selectaddress-${i}`}
                                    name="selectaddress"
                                    className="mt-2 select_address_button"
                                    value={item.addressId}
                                    defaultChecked={i === 0}
                                    onClick={() => handleAddressSelect(item.addressId)}
                                />
                                <div className="loginid_address">
                                    <span className="userName_address address_description">{item?.name}</span>
                                    <h6 className="my-1 address_description">{item?.contatctNo}</h6>
                                    <span className="mb-0 address_description">
                                        {item?.addressLine1} {item?.addressLine2} {item?.city} {item?.stateName} {item?.countryName} {item?.pincode}
                                    </span>
                                </div>
                            </div>
                            <button onClick={() => onEdit(item)} className="edit_button">
                                <img src='./images/edit.svg' alt="Hand-stitched embroidered kurta – Gailee" />
                            </button>
                        </div>
                        <div className="address_bottom_border"></div>
                    </div>
                ))}
            </div>

            <div className="add_more_address_btn mt-2">
                <button className="web_buttons" onClick={handleAddAddressClick}>+ Address</button>
                {visibleCount < userAddress?.length && !isExpanded && (
                    <button className="web_buttons" onClick={handleShowMore}>
                        Show More...
                    </button>
                )}
                {isExpanded && (
                    <button className="web_buttons" onClick={handleShowLess}>
                        Show Less
                    </button>
                )}
            </div>
        </div>
    )
}

export default UserAddress;